"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRegistrationData = void 0;
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _contexts = require("../../../contexts");
var _useTranslations_simplifiedRegistrationBrandPartner = require("../../../hooks/useTranslations_simplified-registration-BrandPartner");
var _interfaces = require("../../../interfaces");
var _FetchResult = require("../../FetchResult");
var _TranslationKey_simplifiedRegistrationBrandPartner = require("../../TranslationKey_simplified-registration-BrandPartner");
// this api not calling with swr, because we have some problem with cache
const useRegistrationData = reFetchkey => {
  const [registrationData, setRegistrationData] = (0, _react.useState)();
  const {
    registrationId,
    registrationType
  } = (0, _contexts.useConfiguration)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const api = (0, _globalApiClientReact.useApiClient)();
  const {
    formatMessage
  } = (0, _useTranslations_simplifiedRegistrationBrandPartner.useTranslations)();
  const {
    notificationData
  } = (0, _contexts.useNotificationData)();
  const {
    setNotificationData
  } = notificationData;
  const navigateConsultantUrl = `/join-us/self-registration`;
  const navigateVipUrl = `/join-us/self-vip-registration`;
  const errorMeesage = formatMessage(_TranslationKey_simplifiedRegistrationBrandPartner.TranslationKey.cannotGetData);
  (0, _react.useEffect)(() => {
    const getData = async () => {
      if (registrationId) {
        try {
          const getResponse = await (0, _globalApiClientReact.getCustomerRegistration)(api, registrationId);
          const result = new _FetchResult.FetchResult(getResponse.status);
          if (result.isSuccess()) {
            setRegistrationData(getResponse.data);
          }
        } catch (error) {
          const errorResponse = error;
          const statusNotFound = errorResponse.response?.status === _globalApiClientReact.HttpStatusCodes.status404NotFound;
          setNotificationData({
            isOpen: true,
            message: errorMeesage,
            type: _interfaces.MessageType.error,
            messageId: 'cannotGetData'
          });
          if (statusNotFound) {
            window.location.href = registrationType === 'VipCustomer' ? navigateVipUrl : navigateConsultantUrl;
          }
        }
      }
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps --- not needed updated on other property
  }, [tenant, registrationId, reFetchkey]);
  return {
    data: registrationData
  };
};
exports.useRegistrationData = useRegistrationData;